export default __webpack_public_path__ + "static/media/ความสำคัญของกิจกรรม-2.698e3cfb.png";